/* eslint-disable */
import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { appColors } from './Styles/ColorStyles';

export const fontColor = {
    active: `${appColors.darkGray} !important`,
    disabled: `${appColors.mediumGray} !important`,
    tRoweBlue: `${appColors.brightBlue} !important`,
    linkColor: `${appColors.interactiveBlue}`,
    linkColorHover: `${appColors.hoverBlue}`
};


export const spacing = {
    medium: '12px',
    xmedium: '16px',
    xxmedium: '20px',
    xxxmedium: '24px',
    large: '28px',
    xlarge: '32px'
};

export const fontSize = {
    xxsmall: '10px',
    xsmall: '12px',
    small: '14px',
    medium: '16px',
    xmedium: '18px',
    large: '20px',
    xlarge: '24px',
    xxlarge: '36px',
    xxxlarge: '48px',
    titleFont: '18px',
    labelSupFont: '100%',
    h1Font: '56px',
    h2Font: '48px',
    h3Font: '40px',
    h4Font: '32px',
    h5Font: '24px',
    h6Font: '20px',
    subtitle1: '16px',
    body1: '16px',
    body2: '12px',
    caption: '12px',
    p1Font: '16px',
    p2Font: '14px',
    h1FontMobile: '40px',
    h2FontMObile: '32px',
    h3FontMobile: '32px',
    h4FontMobile: '24px',
    h5FontMobile: '24px',

};

export const borderBoxSizing = 'border-box';

export const materialStyler = {
    cardMediaWrapper: {
        background: appColors.hoverBlue,
        border: `1px solid ${appColors.brightBlue}`,
        borderRadius: 4,
        boxSizing: 'border-box',
        height: 40,
        position: process.env.REACT_APP_ENV === 'local' ? 'absolute' : 'none'
    }
};

export const fontFamily = {
    nimbusSansReg: 'Nimbus Sans Reg',
    nimbusSansBold: 'Nimbus Sans Bold',
    nimbusSansLight: 'Nimbus Sans Light'
};

export const coClientUseStyles = makeStyles({
    titleHeader: {
        color: '#fff',
        fontSize: 32,
        lineHeight: '32px',
        fontFamily: fontFamily.nimbusSansReg,
        paddingBottom: 8
    },
    continuePlanning: {
        background: appColors.interactiveBlue,
        boxShadow: 'none',
        width: 187,
        maxWidth: 187,
        // padding: '8x 16px',
        fontSize: 16,
        fontFamily: fontFamily.nimbusSansBold,
        color: '#fff',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: appColors.darkBlue
        }
    },
    arrowForward: {
        fontSize: '1rem !important',
        marginLeft: 4,
        verticalAlign: 'middle'
    },
    popoverTelephoneLink: {
        color: '#fff',
        borderBottom: '1px solid #fff',
        '&:hover': {
            backgroundColor: appColors.hoverBlue,
            textDecoration: 'none'
        }
    },
    cardButton: {
        boxShadow: 'none !important',
        background: `${appColors.interactiveBlue} !important`,
        padding: '8px 16px !important',
        fontSize: '16px !important',
        fontFamily: `${fontFamily.nimbusSansBold} !important`,
        color: '#fff !important',
        textTransform: 'capitalize !important',
        marginRight: '16px !important',
        marginBottom: '8px !important',
        '&:hover': {
            backgroundColor: '#054C70 !important'
        },
        '&$disabled': {
            color: 'white',
            background: appColors.interactiveBlue,
        },

    }
});

const fpsUseStyles = {
    coClientStyles: makeStyles( theme => ({
        root: {
            margin: '0',
            // padding: theme.spacing(2),
            background: appColors.hoverBlue,
            flexGrow: '1 !important',
            padding: '32px 24px !important',
            [theme.breakpoints.only('sm')]: {
                flexGrow: '0 !important'
            }
        },
        closeButton: {
            position: 'absolute !important',
            right: 0,
            top: 0,
            '&:hover': {
                background: `${appColors.hoverBlue}`
            }
        },
        closeButtonLoader:{
            color: fontColor.tRoweBlue
        },
        imageBox: {
            [theme.breakpoints.up('md')]: {
                marginRight: 24
            },
            [theme.breakpoints.down('sm')]: {
                padding: '16px 0px'
            }

        },
        icon: {
            color: '#fff',
            '&:hover': {
                color: `${appColors.brightBlue}`
            }
        }
    }))
}

export const CoClientBodyTypography = withStyles({
    root: {
        fontSize: fontSize.medium,
        lineHeight: '22px',
        color: '#fff',
        fontFamily: fontFamily.nimbusSansLight
    }
})(props => <Typography {...props}>{props.children}</Typography>);

export default fpsUseStyles;

